var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-approval',{attrs:{"api":"home-delete-request","perm-prefix":"approve_delete_home","columns":_vm.columns,"final-word":"ລຶບ","final-confirm":(n) => `ລຶບລູກຄ້າສາຍບ້ານ ${n} ລາຍ ພ້ອມບິນ ແລະ ບັນຊີ login? ລູກຄ້າທີ່ລຶບແລ້ວຈະເຫັນຢູ່ໜ້າປະຫວັດ.`}})
}
var staticRenderFns = []

export { render, staticRenderFns }